export default __webpack_public_path__ + "static/media/cover-bg.acab0a29.jpg";